import { useEffect, useState } from 'react';

/**
 * 화면 배율(`devicePixelRatio`)을 들고 있다가 바뀌면 다시 그리게 한다 (44회차).
 *
 * 캔버스 둘(X-View·추이 그래프)은 `ResizeObserver`가 부를 때만 배율을 읽었다. 확대·축소는
 * CSS 크기가 같이 바뀌어 잡히지만, 크기가 같은 채 배율이 다른 모니터로 창을 옮기면 캔버스가
 * 옛 배율로 남아 흐리거나 지나치게 잘게 그려진다. `(resolution: Ndppx)` 미디어 쿼리는 배율이
 * 그 값에서 벗어날 때 한 번 알리므로, 알릴 때마다 새 배율로 다시 건다.
 */

export function currentPixelRatio(): number {
  return typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1;
}

export function usePixelRatio(): number {
  const [ratio, setRatio] = useState(currentPixelRatio);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    let query: MediaQueryList | undefined;
    const onChange = () => {
      setRatio(currentPixelRatio());
      listen();
    };
    const listen = () => {
      query?.removeEventListener('change', onChange);
      query = window.matchMedia(`(resolution: ${currentPixelRatio()}dppx)`);
      query.addEventListener('change', onChange);
    };
    listen();
    return () => query?.removeEventListener('change', onChange);
  }, []);

  return ratio;
}
